import React from 'react';
import Link from '@mui/material/Link';

/**
 * Tooltip body for a locked Case Master case: the reason, with the word
 * `linkText` ("Upgrade") linkified in place to the landing page's pricing
 * section. Rendered as the `message` of NoAccessTooltip.
 *
 * MUI v5 tooltips are interactive by default, so the link stays reachable while
 * the pointer travels from the disabled button onto the tooltip.
 */
export default function CaseMasterLockMessage({
  message = '', upgradeUrl = '', linkText = '',
}) {
  const linkStart = linkText ? message.indexOf(linkText) : -1;

  // Nothing to link (or the copy changed and no longer contains the word):
  // degrade to the plain sentence rather than dropping the message.
  if (!upgradeUrl || linkStart === -1) return message;

  return (
    <span>
      {message.slice(0, linkStart)}
      <Link
        href={upgradeUrl}
        target="_blank"
        rel="noopener noreferrer"
        color="inherit"
        underline="always"
        sx={{ fontWeight: 700, cursor: 'pointer' }}
      >
        {linkText}
      </Link>
      {message.slice(linkStart + linkText.length)}
    </span>
  );
}
